export const ERROR_LOGIN_REQUIRED = 'Login required';
export const ERROR_CONSENT_REQUIRED = 'Consent required';
export const FORCE_LOGIN_PARAM = 'authenticatedSession';
